import { ENV } from '../../config/runtimeEnv';
import { getSessionUser } from "../../utils/auth/sessionUser";
import { Sample} from "../../types/lab/SampleTypes";
import { sessionLabiqUserId } from "../../utils/auth/labiqUserId";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_LABIQ_SERVER;

////////////////////////// sample management api calls
export const fetchSamples = async (
	page: number,
	perPage: number,
	sortBy: string = "sampleID",
	sortOrder: string = "desc",
	search?: string,
	statusFilter?: string,
	includeProtocols?: boolean
): Promise<{
	data: Sample[];
	total: number;
}> => {
	const response = await http.post(
		`${API_BASE_URL}/samples`,
		{},
		{
			params: {
				page,
				per_page: perPage,
				sort_by: sortBy,
				sort_order: sortOrder,
				search: search,
				status_filter: statusFilter,
				include_protocols: includeProtocols
			},
		}
	);

	return {
		data: response.data.data,
		total: response.data.total,
	};
};

export const fetchSample = async (id: string): Promise<Sample> => {
	const response = await http.get<Sample>(`${API_BASE_URL}/samples/${id}`);
	return response.data;
};

// Update an existing sample
export const updateSample = async (id: number, sampleData: Sample) => {
	await http.put(
		`${API_BASE_URL}/samples/${id}`,
		{
			sample: sampleData,
			username: getSessionUser().username,
			user_id: sessionLabiqUserId(),
		}
	);
};

// Request a new analysis on an existing sample
export const NewAnalysisRequest = async (id: number, analysis: string[]): Promise<Sample> => {
	const response = await http.put(
		`${API_BASE_URL}/samples/${id}/analysis`,
		{
			analysis_requested: analysis,
			username: getSessionUser().username,
			user_id: sessionLabiqUserId(),
		}
	);

	// SampleController::requestNewAnalysis answers { message, sample }.
	return response.data.sample as Sample;
};

// Create a new sample
export const createSample = async (sampleData: Sample) => {
	const response = await http.post(
		`${API_BASE_URL}/samples/create`,
		{
			sample: sampleData,
			username: getSessionUser().username,
			user_id: sessionLabiqUserId(),
		}
	);
	return response.data.sample;
};

export const deleteSample = async (sampleID: number) => {
	await http.delete(`${API_BASE_URL}/samples/${sampleID}`);
};


//Get data for the dashboard

export const getDashboardData = async (
	start: Date,
	end: Date
): Promise<{
	totals: number[];
	samples: Sample[]
}> => {
	// Convert start date to beginning of day (00:00:00)
	const startOfDay = new Date(start);
	startOfDay.setHours(0, 0, 0, 0);
	const startDateStr = startOfDay.toISOString().split("T")[0];

	// Convert end date to end of day (23:59:59.999)
	const endOfDay = new Date(end);
	endOfDay.setHours(23, 59, 59, 999);
	const endDateStr = endOfDay.toISOString();

	const response = await http.get(`${API_BASE_URL}/dashboard`, {
		params: {
			start: startDateStr,
			end: endDateStr,
		},
	});

	return {
		totals: [response.data.sampleTotal, response.data.batcheTotal],
		samples: response.data.samples
	};
};



/**
 * Bulk fetch samples by IDs - Optimized endpoint
 * Fetches multiple samples in a single request
 */
export const bulkFetchSamples = async (
	sampleIds: string[],
	includeProtocols: boolean = true
): Promise<{
	data: Sample[];
	total: number;
	requested: number;
	found: number;
	not_found: string[];
}> => {
	const response = await http.post(
		`${API_BASE_URL}/samples/bulk-fetch`,
		{
			sample_ids: sampleIds,
			include_protocols: includeProtocols
		},
		{
			headers: {
				'Content-Type': 'application/json',
			},
		}
	);

	return response.data;
};

export const reAnalyseSample = async (sampleId: string): Promise<Sample> => {
	const response = await http.post(
		`${API_BASE_URL}/samples/re-analyse-sample/${sampleId}`,
		{
			triggered_by: sessionLabiqUserId()
		},
		{
			headers: {
				'Content-Type': 'application/json',
			},
		}
	);

	return response.data as Sample;
};